/*jshint -W069 */
/**
 * 
 * @class Api
 * @param {(string|object)} [domainOrOptions] - The project domain or options object. If object, see the object's optional properties.
 * @param {string} [domainOrOptions.domain] - The project domain
 * @param {object} [domainOrOptions.token] - auth token - object with value property and optional headerOrQueryName and isQuery properties
 */
var Api = (function() {
    'use strict';

    var Q = require('q');
    var settingsInstance = require('./SettingsInstance.js');
    var customRequest = require('./requestHelper.js').customRequest;
    var mergeQueryParams = require('./requestHelper.js').mergeQueryParams;

    function Api(options) {
        var domain = (typeof options === 'object') ? options.domain : options;
        this.domain = domain ? domain : settingsInstance.baseApiUrl;
        if (this.domain.length === 0) {
            throw new Error('Domain parameter must be specified as a string.');
        }
    }

    /**
     * HTTP Request
     * @method
     * @name Api#request
     * @param {string} method - http method
     * @param {string} path - path
     * @param {string} url
     * @param {object} body - body parameters / object
     * @param {object} headers - header parameters
     * @param {object} queryParameters - querystring parameters
     * @param {object} form - form data object
     * @param {object} deferred - promise object
     */
    Api.prototype.request = customRequest;

    /**
     * Pobierz zapisany stan Stawek
     * @method
     * @name Api#getEndpointStawki
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     * @param {string} parameters.kod_teryt - Podaj kod teryt by wyszukać stan formularza Stawek
     * @param {string} parameters.rodzaj_drogi - Podaj rodzaj drogi (krajowa, wojewódzka, powiatowa, gminna) lub pozostaw puste
     */
    Api.prototype.getEndpointStawki = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/endpoint_stawki',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        if (parameters['kod_teryt'] !== undefined) {
            queryParameters['kod_teryt'] = parameters['kod_teryt'];
        }

        if (parameters['kod_teryt'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: kod_teryt'));
            return deferred.promise;
        }

        if (parameters['rodzaj_drogi'] !== undefined) {
            queryParameters['rodzaj_drogi'] = parameters['rodzaj_drogi'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('GET', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Pobierz listę województw, gmin, powiatów
     * @method
     * @name Api#getEndpoints
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     * @param {string} parameters.page_number - Numer strony (domyślnie None - zwracana całość)
     * @param {string} parameters.items_per_page - Ilość elementów na stronę (domyślnie None - zwracana całość)
     * @param {string} parameters.order_by - Wg której kolumny sortowanie (domyślnie id)
     * @param {boolean} parameters.desc - Czy sortowanie zstępne
     * @param {string} parameters.filter_str - Treść filtra
     * @param {boolean} parameters.tylko_gminy - Czy tylko gminy - odfiltrowanie dzielnic i delegatur
     * @param {string} parameters.control - Parametr kontrolny
     */
    Api.prototype.getEndpoints = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/endpoints',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        if (parameters['page_number'] !== undefined) {
            queryParameters['page_number'] = parameters['page_number'];
        }

        if (parameters['items_per_page'] !== undefined) {
            queryParameters['items_per_page'] = parameters['items_per_page'];
        }

        if (parameters['order_by'] !== undefined) {
            queryParameters['order_by'] = parameters['order_by'];
        }

        if (parameters['desc'] !== undefined) {
            queryParameters['desc'] = parameters['desc'];
        }

        if (parameters['filter_str'] !== undefined) {
            queryParameters['filter_str'] = parameters['filter_str'];
        }

        if (parameters['tylko_gminy'] !== undefined) {
            queryParameters['tylko_gminy'] = parameters['tylko_gminy'];
        }

        if (parameters['control'] !== undefined) {
            queryParameters['control'] = parameters['control'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('GET', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Pobierz listę stawek za zajęcie pasa drogowego
     * @method
     * @name Api#getStawki
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     * @param {string} parameters.page_number - Numer strony (domyślnie None - zwracana całość)
     * @param {string} parameters.items_per_page - Ilość elementów na stronę (domyślnie None - zwracana całość)
     * @param {string} parameters.order_by - Wg której kolumny sortowanie (domyślnie id)
     * @param {boolean} parameters.desc - Czy sortowanie zstępne
     * @param {string} parameters.filter_str - Treść filtra
     * @param {string} parameters.control - Parametr kontrolny
     */
    Api.prototype.getStawki = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/stawki',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        if (parameters['page_number'] !== undefined) {
            queryParameters['page_number'] = parameters['page_number'];
        }

        if (parameters['items_per_page'] !== undefined) {
            queryParameters['items_per_page'] = parameters['items_per_page'];
        }

        if (parameters['order_by'] !== undefined) {
            queryParameters['order_by'] = parameters['order_by'];
        }

        if (parameters['desc'] !== undefined) {
            queryParameters['desc'] = parameters['desc'];
        }

        if (parameters['filter_str'] !== undefined) {
            queryParameters['filter_str'] = parameters['filter_str'];
        }

        if (parameters['control'] !== undefined) {
            queryParameters['control'] = parameters['control'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('GET', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Dodaj Stawki
     * @method
     * @name Api#postStawki
     * @param {object} parameters - method options and parameters
     * @param {} parameters.body - 
     * @param {string} parameters.token - Token
     */
    Api.prototype.postStawki = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/stawki',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['body'] !== undefined) {
            body = parameters['body'];
        }

        if (parameters['body'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: body'));
            return deferred.promise;
        }

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('POST', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Pobierz zapisany stan Stawek
     * @method
     * @name Api#getStawkiCsv
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     */
    Api.prototype.getStawkiCsv = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/stawki.csv',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('GET', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Dodaj plik w zasileniu manualnym
     * @method
     * @name Api#postStawkiZalaczniki
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     * @param {file} parameters.file1 - Plik
     * @param {file} parameters.file2 - Plik
     * @param {file} parameters.file3 - Plik
     * @param {file} parameters.file4 - Plik
     * @param {file} parameters.file5 - Plik
     * @param {file} parameters.file6 - Plik
     * @param {file} parameters.file7 - Plik
     * @param {file} parameters.file8 - Plik
     * @param {file} parameters.file9 - Plik
     * @param {file} parameters.file10 - Plik
     */
    Api.prototype.postStawkiZalaczniki = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/stawki_zalaczniki',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['multipart/form-data'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        if (parameters['file1'] !== undefined) {
            files['file1'] = parameters['file1'];
        }

        if (parameters['file2'] !== undefined) {
            files['file2'] = parameters['file2'];
        }

        if (parameters['file3'] !== undefined) {
            files['file3'] = parameters['file3'];
        }

        if (parameters['file4'] !== undefined) {
            files['file4'] = parameters['file4'];
        }

        if (parameters['file5'] !== undefined) {
            files['file5'] = parameters['file5'];
        }

        if (parameters['file6'] !== undefined) {
            files['file6'] = parameters['file6'];
        }

        if (parameters['file7'] !== undefined) {
            files['file7'] = parameters['file7'];
        }

        if (parameters['file8'] !== undefined) {
            files['file8'] = parameters['file8'];
        }

        if (parameters['file9'] !== undefined) {
            files['file9'] = parameters['file9'];
        }

        if (parameters['file10'] !== undefined) {
            files['file10'] = parameters['file10'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('POST', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    return Api;
})();

exports.Api = Api;